import { AutogenModelBrltlCommodity, AutogenRowBrltlCommodity } from "./autogen/AutogenModelBrltlCommodity";

export class ModelBrltlCommodity extends AutogenModelBrltlCommodity<RowBrltlCommodity> {
    constructor() {
        super(RowBrltlCommodity);
    }
}

export class RowBrltlCommodity extends AutogenRowBrltlCommodity {
}